import Loading from '../../../Common/Loading';
import { AdministrativeStructureEvolutionChart } from './AdministrativeStructureEvolutionChart';
import { CouncilCompositionEvolutionChart } from './CouncilCompositionEvolutionChart';
import { GeneralEvolutionChart } from './GeneralEvolutionChart';
import { OperatingDynamicsEvolutionChart } from './OperatingDynamicsEvolutionChart';
import { PopulationEvolutionChart } from './PopulationEvolutionChart';
import { SizeEvolutionChart } from './SizeEvolutionChart';
import { useIDCONSELHOChartsDataContext } from './hooks/useIDCONSELHOChartsDataContext';


export const Charts = () => {
    const { isLoading } = useIDCONSELHOChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="chats-indicators-side-by-side-dashboards">
                <GeneralEvolutionChart />
                <PopulationEvolutionChart />
            </div>

            <div className="chats-indicators-side-by-side-dashboards">
                <SizeEvolutionChart />
                <AdministrativeStructureEvolutionChart />
            </div>

            <div className="chats-indicators-side-by-side-dashboards">
                <OperatingDynamicsEvolutionChart />
                <CouncilCompositionEvolutionChart />
            </div>
        </>
    );
};
